
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import blogData from "../blogData.json";
import blogBg from "../../../assests/blog/angu (1).png";

const InternetMarketingServices = () => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <div className="mx-auto px-4 py-12">
      {/* Relative wrapper for positioning */}
      <div className="relative w-full h-[400px] mb-6">
        <img
          src={blogBg}
          className="w-full h-full object-cover opacity-90 rounded-lg"
          alt="Blog Background"
        />

        {/* Centered Text */}
        <div className="absolute inset-0 flex items-center justify-center px-4">
          <h1 className="text-center text-[45px] lg:text-4xl font-recoleta text-white max-w-3xl">
          Internet marketing services
          </h1>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4">
      <h1 className="font-bold text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">
      Internet marketing services USA, social media optimization, grow your business, online marketing experts, increase business sales.
            </h1>
        <div className="text-left">
          <div className="h-12 border-l-2 px-8 border-blue-600">
            <h1 className="font-bold text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">
            Why do internet marketing services help to boost business growth quickly? :
            </h1>
          </div>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-20 lg:mt-12">
          Many business owners in the United States are unaware of how powerful and useful internet marketing services USA can be. In today’s digital era, it is more than necessary to invest time and effort in marketing your business online. We are here to tell you exactly how internet marketing can help grow your business, get you more customers and generate more leads.
          </p>
      
        </div>
        <div className="text-left">
          <div className="font-bold h-20 border-l-2 px-8 border-blue-600">
            <h1 className=" text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">The most important internet marketing strategies you need do implement in your business today are: :

</h1>
          </div>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-20 lg:mt-12">
          1. Perhaps, the most important strategy in internet marketing is SEO. SEO stands for search engine optimization and is a powerful tool to help rank your website higher on search engines.

          </p>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-10 lg:mt-6">
          2. Another strategy to gain more customers is PPC or pay-per-click. This advertising technique allows you to earn money, when users click ads displayed on your website.

          </p><p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-10 lg:mt-6">
          3. In addition to these strategies, having a user friendly and dynamic website is very important. An ideal website should provide all the relevant information while still keeping it simple enough for customers to navigate. Always make sure to update the contact information on your website and prompt customers to follow your business on social media channels too.

          </p><p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-10 lg:mt-6">
          4. Social media optimization is necessary to engage in a conversation with your customers. Regularly updating your social media channels, with relevant content and new products is crucial. This strategy is proven to increase customer loyalty and increase business sales drastically.

          </p>
        </div>
        <div className="text-left">
          <div className="font-bold h-20 border-l-2 px-8 border-blue-600">
            <h1 className=" text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">Online marketing experts have claimed that incorporating these techniques in internet marketing can help boost your business quickly in the following ways:</h1>
          </div>
          <h1 className=" text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-32 lg:mt-12">1. Consistent brand</h1>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-8 lg:mt-4">
          Internet marketing allows businesses to establish their name, logo and slogan, all over the internet to create a consistent brand. This also helps to bridge the gap between small and big businesses alike.
          </p>
          <h1 className=" text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-6"> 2. Increased customer relationships</h1>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-8 lg:mt-4">
          It is proven to enhance customer interaction and acquisition. In this digital age, when everybody is online, establishing internet marketing services USA will allow customers to engage with their favorite brands easily.
          </p><h1 className=" text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-6"> 3. Cost-effective </h1>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-8 lg:mt-4">
          Internet marketing is more cost-efficient than traditional marketing. With internet marketing, you can also monitor and grow your business more easily, with the help of tools such as Google Analytics.
          </p><h1 className=" text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-6"> 4. Targeted audience</h1>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-8 lg:mt-4">
          Internet marketing can help advertise your products and services to a targeted audience. This helps in effective lead generation at lower costs. For example, Facebook advertising permits you to target a particular group of customers, who have expressed interest in a specific niche.
          </p><h1 className=" text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-6"> 5. Higher search rankings</h1>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-8 lg:mt-4">
          Implementing search engine optimization techniques will help your website rank higher on the internet, leading to higher visibility of your brand and a wider range of customers. It is no surprise that most businesses today, whether small or large are using internet marketing services to boost their business quickly. It is easy to use, cost-effective and helps generate more leads very quickly.
          </p>
        </div>
    


      </div>

    </div>
  );
};

export default InternetMarketingServices;
